<template>
    <div class="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
        <div class="kt-portlet kt-portlet--mobile">
            <div class="kt-portlet__head kt-portlet__head--lg no-border-radius">
                <div class="row align-content-center" style="width: 100%">
                    <Dropdown v-model="selectedOrg" :options="organizationsList" optionLabel="display_name" filter
                              :placeholder="$t('AppOperationsExportHistory.Organização')"
                              class="dropdown-width-org dropdown-250" dataKey="id">
                        <template #option="slotProps" style="width: 500px">
                            <div v-if="loadingClients">
                                {{ $t('AppOperationsExportHistory.Carregando, aguarde') }}
                            </div>
                            <div v-else>
                                {{ slotProps.option.display_name }}
                            </div>
                        </template>
                    </Dropdown>
                </div>
            </div>
            <div class="kt-portlet__body no-padding">
                <div v-if="!selectedOrg" class="row no-gutters text-center mt-5">
                    <h3 class="col-12">
                        {{ $t('AppOperationsExportHistory.Selecione a organização para acessar o histórico de arquivos exportados') }}
                    </h3>
                </div>
                <AppOperationsExportHistoryTable v-else :grid-data="gridData" :fields="fieldsList" :loading="loading"
                                                     @download="downloadFile"/>
            </div>
        </div>
    </div>
</template>

<script>

import DataTable from "primevue/datatable";
import MultiSelect from "primevue/multiselect";
import Dropdown from "primevue/dropdown";
import AppOperationsExportHistoryTable from "./AppOperationsExportHistoryTable.vue";

import FieldsService from "@/services/FieldsService";
import OrganizationsService from "@/services/OrganizationsService";
import OperationsService from "@/services/OperationsService";

import JSZip from "jszip";

import dateHourFormat from "@/mixins/DateMixin";

export default {
    mixins: [dateHourFormat],
    mounted() {
        this.operationsService = new OperationsService();
        this.organizationsService = new OrganizationsService();
        this.fieldsService = new FieldsService();
        this.getOrgs();
    },
    beforeDestroy() {
        clearTimeout(this.timeout)
    },
    data() {
        return {
            operationsService: null,
            organizationsService: null,
            fieldsService: null,
            loading: false,
            selectedOrg: null,
            organizationsList: [],
            loadingClients: false,
            selectedField: null,
            fieldsList: [],
            loadingFields: false,
            gridData: [],
            changedOrg: false,
            timeout: null
        }
    },
    methods: {
        getOrgs() {
            this.organizationsService.getAllV3('AGRICULTURE')
                .then((response) => {
                    this.organizationsList = response.sort((a, b) => a.name.localeCompare(b.name));
                    this.selectSavedOrg();
                })
                .catch(() => {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppOperationsExportHistory.Não foi possivel buscar as organizações'),
                        life: 5000
                    });
                })
                .finally(() => {
                    this.loadingClients = false;
                })
        },
        selectSavedOrg() {
            if (this.organizationsList.length === 1) {
                this.selectedOrg = this.organizationsList[0];
                return;
            }

            let storedChosenOptions = JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE_AGRO_FILTER_OPTIONS));

            if (!storedChosenOptions || !storedChosenOptions.selectedOrg) {
                return;
            }

            let foundOrg = this.organizationsList.find(obj => obj.id === storedChosenOptions.selectedOrg);
            if (foundOrg) {
                this.selectedOrg = foundOrg;
            }
        },
        getFieldsFromOrg(val) {
            this.loadingFields = true;
            this.fieldsList = [];
            this.fieldsService.getFieldsSummaryV3(val.id)
                .then((response) => {
                    this.fieldsList = response.fields.sort((a, b) => a.name.localeCompare(b.name));
                })
                .catch((error) => {
                    if (!error.response || error.response.status !== 403) {
                        this.$toast.add({
                            severity: 'error',
                            summary: this.$t('AppOperationsExportHistory.Não foi possivel completar a operação, Tente novamente'),
                            life: 5000
                        });
                        return;
                    }
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppOperationsExportHistory.Você não tem acesso a esta funcionalidade'),
                        life: 5000
                    });
                })
                .finally(() => {
                    this.loadingFields = false;
                    this.changedOrg = true;
                })
        },
        saveFilterOptions() {
            let storedChosenOptions = JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE_AGRO_FILTER_OPTIONS));
            storedChosenOptions["selectedOrg"] = this.selectedOrg.id;
            localStorage.setItem(process.env.VUE_APP_LOCAL_STORAGE_AGRO_FILTER_OPTIONS, JSON.stringify(storedChosenOptions));
        },
        getExportHistory() {
            this.loading = true;
            this.operationsService.getExportHistory(this.selectedOrg.id)
                .then(response => {
                    this.gridData = this.parseResponse(response);
                    this.timeout = setTimeout(this.getExportHistory, 10000);
                })
                .catch(() => {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppOperationsExportHistory.Erro ao carregar os arquivos exportados'),
                        life: 5000
                    });
                    clearTimeout(this.timeout)
                })
                .finally(() => {
                    this.loading = false;
                })
        },
        parseResponse(response) {
            if (!response) {
                return;
            }
            let data = response.sort((a, b) => b.last_modified_date - a.last_modified_date);
            data.forEach(row => {
                row.formatted_created_date = this.dateHourFormat(row.created_date);
                row.formatted_last_modified_date = this.dateHourFormat(row.last_modified_date);
            })

            return data;
        },
        downloadFile(exportRequest) {
            this.$toast.add({
                severity: 'info',
                summary: this.$t('AppOperationsExportHistory.Requisição realizada com sucesso'),
                detail: this.$t('AppOperationsExportHistory.Aguarde o download do arquivo'),
                life: 3000
            });

            this.operationsService.downloadFile(exportRequest.operation_id, exportRequest.export_request_id)
                .then((response) => {
                    return JSZip.loadAsync(response.data);
                })
                .then((zip) => {
                    let fileName = Object.keys(zip.files)[0];
                    return zip.folder(fileName).generateAsync({type: "uint8array"});
                })
                .then((data) => {
                    let bytes = new Uint8Array(data)
                    if (bytes.length === 0) {
                        this.$toast.add({
                            severity: 'error',
                            summary: this.$t('AppOperationsExportHistory.Não foi possível baixar o arquivo'),
                            life: 3000
                        });
                        return;
                    }

                    let blob = new Blob([data], {type: "application/zip"});
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = `${exportRequest.file_name}.zip`;
                    link.click();
                })
                .catch(() => {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppOperationsExportHistory.Não foi possível baixar o arquivo'),
                        life: 3000
                    });
                })
        }
    },
    watch: {
        selectedOrg: function (val) {
            this.saveFilterOptions();
            this.getFieldsFromOrg(val);
            this.getExportHistory();
        }
    },
    components: {
        Dropdown,
        MultiSelect,
        DataTable,
        AppOperationsExportHistoryTable
    }
}
</script>

<style scoped>

.dropdown-250 {
    width: 250px;
}

@media (max-width: 519px) {
    .dropdown-width-org {
        margin: 10px 10px 10px 10px !important;
    }
}
</style>
